export const STEP_LIST = "STEP_LIST";
export const SET_MIXED = "SET_MIXED";
export const SET_LOW_PLATE = "SET_LOW_PLATE";
export const SET_HIGH_PLATE = "SET_HIGH_PLATE";
export const SET_MIN_PLATE = "SET_MIN_PLATE";
export const SET_MAX_PLATE = "SET_MAX_PLATE";
export const SET_GEOMETRY = "SET_GEOMETRY";
